import { Input } from "../ui/input";
import { Label } from "../ui/label";

type FormFieldProps = {
    id: string;
    label: string;
    placeholder?: string;
    type: string;
    value: string;
    error?: string;
    required?: boolean;
    onBlur: () => void;
    onChange: (value: string) => void;
};

const ContactField = ({
    id,
    label,
    placeholder,
    type,
    value,
    error,
    required = false,
    onBlur,
    onChange,
}: FormFieldProps) => (
    <div className="w-full">
        <Label htmlFor={id}>
            {label} {required && "*"}
        </Label>
        <Input
            className={error ? "border-text-text-error" : ""}
            id={id}
            onBlur={onBlur}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            required={required}
            type={type}
            value={value}
        />
        {error && <p className="text-sm text-text-error">{error}</p>}
    </div>
);

export default ContactField;
